<template>
  <div class="card mb-3" style="min-height: 60vh;">
    <!-- drawer for adding -->
    <a-drawer :visible="showDrawer.length > 0" :width="480" placement="right" @close="onClose">
      <a-spin :spinning="spinning">
        <h2>{{ drawerName }} Account Template</h2>
        <form id="form-proper">
          <br>
          <h6 class="heading-small text-muted">Basic Information</h6>
          <base-input alternative="" label="Template Name" placeholder="Template Name" v-model="templateName"
            input-classes="form-control" :disabled="showDrawer === 'view'" />
          <base-input alternative="" label="Template Code" placeholder="Template Code" v-model="templateCode"
            input-classes="form-control" :disabled="showDrawer === 'view'" />
          <base-input label="Show Label:" class="label-show-label" :disabled="showDrawer === 'view'"><br>
            <a-radio-group name="showLabel" v-model="showLabel">
              <a-radio :value="1">
                      Yes
              </a-radio>
            <a-radio :value="0">
                      No
            </a-radio>
            </a-radio-group>
          </base-input>

          <label for="tree"><strong>Available Modules *</strong></label>
          <a-tree id="tree" :checkedKeys="checkedKeys" checkable :disabled="showDrawer === 'view'" showLine
            :expandedKeys="expandedKeys" :defaultExpandAll="defaultExpandAll" @expand="onExpand" @check="onCheck"
            :treeData="availableModules" :defaultSelectedKeys="defaultSelectedKeys" v-if="showDrawer">
            <template slot="title" slot-scope="{title}">
              <span>{{ title }} </span>
            </template>
          </a-tree>
          <div>
              
              <h6 class="heading-small text-muted mb-4">ACCOUNT LICENSE SETTINGS</h6>
              
              <base-alert v-if="errors.length" type="danger">
                  <b>You have the following error(s):</b>
                  <li v-for="error in errors" :key="error">{{ error }}</li>
              </base-alert>

              <base-alert v-if="messages != null" type="success">
                  {{messages}}
              </base-alert>

              <form>
                  <div class="row">
                      <div class="col-lg-6">
                          <base-input alternative="" min="0" type="number" label="No. of License" input-classes="form-control" v-model="inputNoOfTerminal"  />
                      </div>
                      <div class="col-lg-6">
                          <base-input alternative="" min="0" type="number" label="No. of User" input-classes="form-control" v-model="inputNoOfUser"  />
                      </div>
                      <div class="col-lg-12">
                          <base-input alternative="" min="0" type="number" label="No. of Concurrent User (HO)" input-classes="form-control" v-model="maxConcurrentUserHo"  />
                      </div>
                  </div>
              </form>
          </div>

          <button type="button" class="btn btn-sm btn-secondary float-right" @click.prevent="onClose">Close</button>
          <a-popconfirm title="This will apply to all accounts under this template. Click Proceed to continue." @confirm="processRequest()" okText="Proceed" cancelText="Cancel">
            <button type="button" class="btn btn-sm btn-primary float-right mr-3" ref="action" v-if="showDrawer !== 'view'">{{ drawerAction }}</button>
          </a-popconfirm>
          
          <br>

        </form>
      </a-spin>
    </a-drawer>

    <!-- table of templates -->
    <a-spin :spinning="spinning2">
    <div style="min-height: 60vh;">
      <div class="card-body">
        <div class="row">
          <div class="col-md-10">
            <h2>Template List</h2>
          </div>
          <div class="col-md-2"><button class="btn btn-sm btn-default float-right"
              @click.prevent="showSelectedDrawer('create')">+ Add
              Template</button></div>
          <div class="table-responsive">
            <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields"
              :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data"
              @vuetable:load-error="onLoadError" @vuetable:pagination-data="onPaginationData">

              <template slot="actions" slot-scope="props">
                <center>
                  <div class="table-button-container">
                    <button id="view" class="btn btn-success btn-sm"
                      @click.prevent="showSelectedDrawer('view', props.rowData)">View</button>

                    <button class="btn btn-warning btn-sm"
                      @click.prevent="showSelectedDrawer('edit', props.rowData)">Edit</button>

                    <a-popconfirm title="You are about to delete this record?" @confirm="deleteRow(props.rowData.id)"
                      okText="Delete" cancelText="Cancel">
                      <a class="btn btn-danger btn-sm text-white">Delete</a>
                    </a-popconfirm>
                  </div>
                </center>

              </template>

            </vuetable>
          </div>

          <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
            <div class="pagination ui basic segment grid">
              <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"
                :css="css.pagination">
              </vuetable-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>
    </a-spin>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import { mapState } from 'vuex'
import axios from 'axios';

const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}

export default {
  components: {
    Vuetable,
    VuetablePagination
  },
  computed: {
    ...mapState(['endPoint', 'profileId', 'serverType', "parameters",
      "categoriesOptions"]),
  },
  data() {
    return {
      showLabel: 0,
      checkedKeys: [],
      halfCheckedKeys: [],
      templateCode: "",
      templateName: "",
      defaultExpandAll: true,
      defaultSelectedKeys: [],
      expandedKeys: [],
      type: "dark",
      showDrawer: "",
      fields: [
        { name: "name", title: "Name" },
        { name: "code", title: "Code" },
        { name: "created_at", title: "Create Date" },
        { name: "__slot:actions", title: "Actions" },
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      apiURL: "",
      css: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      errors: [],
      availableModules: [],
      allModuleKeys: [],
      selectedModuleKeys: [],
      accountSettingInputs:[],
      drawerAction: '',
      drawerName: '',
      productTypeKeysToCheck: [],
      instanceProductTypeKeys: [],
      currentID: null,
      spinning: false,
      spinning2: false,
      inputNoOfTerminal: 0,
      inputNoOfUser: 0,
      maxConcurrentUserHo: 0,
      messages: null,
    }
  },
  watch: {
  },
  mounted: async function () {
    this.apiURL = this.endPoint + "account_templates"
    this.availableModules = await HTTPRequest.getRequest(this.endPoint + 'account_templates/tree_view', null, null)
    this.availableModules.forEach(
      (category) => {
        if (category.key === "System Modules") {
          this.allModuleKeys.push({ name: "System Module Keys", keys: [] })
          if (category.children.length > 0) {
            category.children.forEach((sub_category_level_1) => {
              this.allModuleKeys[0].keys.push(sub_category_level_1.key)
              if (sub_category_level_1.children.length > 0) {
                sub_category_level_1.children.forEach((sub_category_level_2) => {
                  this.allModuleKeys[0].keys.push(sub_category_level_2.key)
                  if (sub_category_level_2.children.length > 0) {
                    sub_category_level_2.children.forEach((sub_category_level_3) => {
                      this.allModuleKeys[0].keys.push(sub_category_level_3.key)
                      if (sub_category_level_3.children.length > 0) {
                        sub_category_level_3.children.forEach((sub_category_level_4) => {
                          this.allModuleKeys[0].keys.push(sub_category_level_4.key)
                        })
                      }
                    })
                  }
                })
              }
            })
          }
        } else if (category.key === "Promotion Types") {
          this.allModuleKeys.push({ name: "Promotion Type Keys", keys: [] })
          if (category.children.length > 0) {
            category.children.forEach(({ key }) => this.allModuleKeys[1].keys.push(key))
          }
        } else {
          this.allModuleKeys.push({ name: "Product Type Keys", keys: [] })
          if (category.children.length > 0) {
            category.children.forEach(({ key }) => {
              this.allModuleKeys[2].keys.push({ [key]: false })
              this.productTypeKeysToCheck.push(key)
            })
          }
        }
      })
    generateList(this.availableModules)
  },
  methods: {
    async processRequest() {
      this.instanceProductTypeKeys = []
      let action = this.$refs.action.innerHTML.toLowerCase()
      let method = action === "create" ? 'post' : 'put'
      let url = action === "create" ? '/account_templates' : `/account_templates/${this.currentID}`

      const hasErrors = this.checkErrors();
      if (hasErrors) {
        return
      } else {
        this.spinning = true
        let instance = JSON.parse(JSON.stringify(this.selectedModuleKeys))
        instance = instance.map((module) => {
          if (module.name === "System Module Keys") {
            this.halfCheckedKeys = this.halfCheckedKeys.filter((key) => typeof (key) === 'number')
            module = { ...module, halfCheckedKeys: this.halfCheckedKeys }
          }
          if (module.name === "Product Type Keys") {
            module.keys.forEach((key) => this.instanceProductTypeKeys.push(Object.keys(key)[0]))
          }
          return module
        })

        this.productTypeKeysToCheck.forEach((key) => {
          if (!this.instanceProductTypeKeys.includes(key)) {
            instance.map((mod) => {
              if (mod.name === "Product Type Keys") {
                mod.keys = [...mod.keys, { [key]: false }]
              }
            })
          }
        })
        
        if(instance.length === 0) {
          this.$notification['error']({
            message: 'Saving Error',
            description: 'No modules were selected or changes made.',
          });
          this.spinning = false
          return
        }
        let account_settings = {
          settings: [
            { code: "no_of_license", name: "Number of License", value: this.inputNoOfTerminal, status: 'A' },
            { code: "no_of_user", name: "Number of User", value: this.inputNoOfUser, status: 'A' },
            { code: "max_concurrent_ho", name: "Max Concurrent Users HO", value: this.maxConcurrentUserHo, status: 'A' }
          ]
        };

        let sitePayload = {
          name: this.templateName,
          code: this.templateCode,
          show_label: this.showLabel,
          id: this.currentID,
          module_template: JSON.stringify(instance),
          account_setting_template: JSON.stringify(account_settings),
        };


        await axios({
          method: method,
          url: `${this.endPoint}${url}`,
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
          },
          data: sitePayload
        }).then(({ data: { status, message } }) => {
          if (status === 200) {
            this.$notification['success']({
              message: 'Success',
              description: message,
            });
          }

        })
        this.spinning = false
        this.$refs.vuetable.refresh();
        this.onClose()
      }
    },

    onCheck(info, e) {
      this.halfCheckedKeys = e.halfCheckedKeys
      this.checkedKeys = info
      this.selectedModuleKeys = []
      this.allModuleKeys.forEach((module) => {
        let current = module.name
        info.forEach((id) => {
          let checkExisting = this.selectedModuleKeys.filter((item) => item.name === current)
          if (module.keys.indexOf(id) !== -1 && module.name !== "Product Type Keys") {
            if (this.selectedModuleKeys.length === 0) {
              this.selectedModuleKeys.push({ name: current, keys: [id] })
            } else {
              if (checkExisting.length === 0) {
                this.selectedModuleKeys.push({ name: current, keys: [id] })
              } else {
                this.selectedModuleKeys.map((mod) => {
                  if (mod.name === current) {
                    mod.keys.push(id)
                  }
                })
              }
            }
          } else if (module.name === "Product Type Keys") {
            module.keys.forEach((key) => {
              let currentKey = Object.keys(key)[0]
              if (currentKey === id) {
                if (this.selectedModuleKeys.length === 0) {
                  this.selectedModuleKeys.push({ name: module.name, keys: [{ [id]: true }] })
                } else {
                  if (checkExisting.length === 0) {
                    this.selectedModuleKeys.push({ name: module.name, keys: [{ [id]: true }] })
                  } else {
                    this.selectedModuleKeys.map((mod) => {
                      if (mod.name === module.name) {
                        mod.keys.push({ [id]: true })
                      }
                    })
                  }
                }
              }
            })
          }
        })
      })
    },

    checkErrors() {
      let errors = [];
      if (this.templateName.length === 0) {
        // If account field is blank
        errors.push('Template Name cannot be empty')
      }
      if (this.templateCode.length === 0) {
        // If site field is blank
        errors.push('Template Code cannot be empty')
      }

      if (errors.length > 0) {
        // Prompt error if there's an error
        errors.forEach((error) => {
          this.$notification['error']({
            message: 'Saving Error',
            description: error,
          });
        })
        return true;
      }
      return false;
    },

    async deleteRow(id) {
      this.spinning2 = true;
      await axios({
        method: 'delete',
        url: `${this.endPoint}/account_templates/${id}`,
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        },
        // data: sitePayload
      }).then(({ data: { status, message } }) => {
        if (status === 200) {
          this.$notification['success']({
            message: 'Success',
            description: message,
          });
        } else {
          this.$notification['error']({
            message: 'Error',
            description: message,
          });
        }

      })
      // this.spinning = false
      this.$refs.vuetable.refresh();
      this.onClose()
      this.spinning2 = false;
    },

    // TREE FUNCTIONS
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    onClose() {
      this.currentID = null
      this.templateName = ""
      this.templateCode = ""
      this.showLabel = 0
      this.showDrawer = false
      this.expandedKeys = []
      this.checkedKeys = []
    },
    async onLoadError(error) {
      console.log(error)
    },
    async onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    showSelectedDrawer(value, rowData) {
      if (value == 'edit')
        this.selectedModuleKeys = JSON.parse(rowData.module_template)
        this.showDrawer = value
      if (value === "edit" || value === "view") {
        this.currentID = rowData.id
        let parsedData = JSON.parse(rowData.module_template)
        parsedData.forEach(({ name, keys }) => {
          if (name === "Product Type Keys") {
            keys.forEach((key) => {
              let current = Object.keys(key)[0]
              if (key[current]) {
                this.checkedKeys.push(Object.keys(key)[0])
              }
            })
          } else {
            keys.forEach((key) => this.checkedKeys.push(key))
          }
        })
        this.accountSettingInputs = JSON.parse(rowData.account_setting_template)

        this.templateName = rowData.name
        this.templateCode = rowData.code
        this.showLabel = rowData.show_label
        this.drawerAction = "Update"
        this.drawerName = _.capitalize(value)
        this.inputNoOfTerminal = this.accountSettingInputs.settings[0].value
        this.inputNoOfUser = this.accountSettingInputs.settings[1].value
        this.maxConcurrentUserHo = this.accountSettingInputs.settings[2].value
      }
      if (value === 'create') {
        this.drawerAction = _.capitalize(value)
        this.drawerName = _.capitalize(value)
      }
    },
  }
}

</script>

<style>
.ant-collapse>.ant-collapse-item-active>.ant-collapse-header {
  background-color: #32325d;
  color: white;
}
</style>


